export default __webpack_public_path__ + "static/media/hair-clear-summer.93699e3f.png";